<div class="profile-page">
    <div class="wrapper">
      <div class="page-header page-header-small" filter-color="green">
        <div class="page-header-image" data-parallax="true" style="background-image: url('assets/images/intro.jpg');">
        </div>
     

        <div class="container">
     
          <div class="content-center">
            <div class="cc-profile-image">
              <a href="#">
                <img src="assets/images/img2.jpg" alt="Image" />
              </a>
            </div>
            <div class="h2 title">Nisa Champagne</div>
          <br>
            <p class="category text-white">Software Developer</p>          
        
            </div>
       
        </div>
        <br>
        <div class="section">
          <div class="container">
            <div class="button-container">
              <a class="btn btn-default btn-round btn-lg btn-icon" href="https://www.linkedin.com/in/nisa-champagne-32782b182/"
                target="_blank" rel="tooltip" title="Check out my Linkedin Profile">
                <i class="fa fa-linkedin"></i>
              </a>
              <a class="btn btn-default btn-round btn-lg btn-icon" href="https://github.com/nisaChampagne"
                target="_blank" rel="tooltip" title="Follow me on Github">
                <i class="fa fa-github"></i>
              </a>
              <a class="btn btn-default btn-round btn-lg btn-icon" href="https://twitter.com/nisa_Champagne"
                target="_blank" rel="tooltip" title="Follow me on Twitter">
                <i class="fa fa-twitter"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>